module.exports = __webpack_public_path__ + "img/profile-icon-bg-white.fbd1a8f8.svg";